import React, { useEffect } from "react";
import Classes from "./styles/style.module.css";
import getProfileImage from "../../Hooks/getProfileImage";
import { useDispatch, useSelector } from "react-redux";
import UsersRequests from "../../services/user";
import VerifedIcon from "../../images/icons/verifiedIcon.svg";
import { useNavigate } from "react-router";

const UserAvatar = () => {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(({ user }) => user);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser?._id) {
      dispatch(UsersRequests.getme());
    }
  }, []);

  return currentUser ? (
    <div className="w-100 d-flex justify-content-between align-items-end">
      <div className={Classes.avatarContainer}>
        {getProfileImage(currentUser.profileImage)}
        <div className={Classes.userInfo}>
          <span>
            <p>{currentUser.fullName}</p>
            <img src={VerifedIcon} alt="verified icon" />
          </span>
          <p>{currentUser.nationalCode}</p>
        </div>
      </div>
      <button
        className={Classes.eidtUserButton}
        onClick={() => navigate("/user/update")}
      >
        ویرایش
      </button>
    </div>
  ) : (
    <div className="w-100 d-flex justify-content-between align-items-end">
      <div className={Classes.avatarContainer}>
        {getProfileImage("")}
        <div className={Classes.userInfo}>
          <span>
            <p>کاربر مهمان</p>
          </span>
          <p className="disabledText">راه بهشت؛ سامانه ارتباطات فرهنگی خانواده گروه فولاد مبارکه</p>
        </div>
      </div>
    </div>
  );
};

export default UserAvatar;
